// src/utils/i18messages/id.js
const id = {
  profile_settings: {
    password_required: "Semua kolom wajib diisi.",
    password_mismatch: "Password baru dan konfirmasi tidak cocok.",
    password_invalid:
      "Password harus minimal 8 karakter, mengandung huruf besar, huruf kecil, angka, dan karakter spesial.",
  },
  register: {
    mustAgreeToTerms:
      "Anda harus menyetujui persyaratan dan kebijakan privasi.",
  },
};

export default id;
